import React, { useEffect, useRef, useState } from "react";
import { postGetAllPlans, postUpSertPlan } from "../../../../core/api/Api";
import DataTable from "../../../_components/datatable/DataTable";
import { useNavigate } from "react-router-dom";

const Plans = () => {
  const mounted = useRef(true);
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    { field: "name", headerName: "Name" },
    { field: "description", headerName: "Description" },
    {
      field: "service",
      headerName: "Service",
      renderCell: (params) => params?.value?.name ?? "",
    },
    {
      field: "category_length_type",
      headerName: "Category Length Type",
      renderCell: (params) =>
        params?.value?.name
          ? params?.value?.name +
            (" (" + params?.value?.general_category?.name + ")")
          : "",
    },
    {
      field: "price",
      headerName: "Price",
      renderCell: (params) =>
        params?.value + " " + params?.row?.currency?.symbol,
    },
  ];

  const getData = (data) => {
    setLoading(true);
    postGetAllPlans(data)
      .then((res) => {
        setLoading(false);
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setData(data);
        }
      })
      .catch((e) => {
        if (mounted.current) setLoading(false);
      });
  };

  const onDeleteDataTableRows = (data) => {
    setLoading(true);
    postUpSertPlan(data)
      .then((res) => {
        setLoading(false);
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setData(data);
        }
      })
      .catch((e) => {
        if (mounted.current) setLoading(false);
      });
  };

  const onRowClick = (e) => {
    navigate("/plan-details/" + e.id);
  };

  const onCreateButtonClick = () => {
    navigate("/plan-details/create");
  };

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <DataTable
      columns={columns}
      data={data}
      loading={loading}
      onPageChangeProp={getData}
      onRowClick={onRowClick}
      onCreateButtonClick={onCreateButtonClick}
      onDeleteDataTableRows={onDeleteDataTableRows}
    />
  );
};

export default Plans;
